module.exports = __webpack_public_path__ + "static/media/qbx-logo-dark.9d689650.svg";